import React from "react";
import styles from "./index.module.scss";

export default function NotesItem({ notes }: { notes: string }) {
  return (
    <div className={styles.noteBox}>
      <span>{notes}</span>
    </div>
  );
}
